import React, { useContext } from 'react'
import View from '../../atoms/View'
import ScoreBar from '../../atoms/Scorebar'
import Space from '../../atoms/Space'
import Text from '../../atoms/TextNew'
import EyeSvg from '../../other/svg/EyeSvg'
import LikedSvg from '../../other/svg/LikedSvg'
import { ItemContext, ItemDispatchContext } from 'src/contexts/itemContext'
import { useDispatch } from 'react-redux'
import { TOGGLE_LIKED_OFFER } from 'dealer-reducers'
import { OPEN_OFFER } from 'src/redux/listLayoutReducer'
import ContractStatusIcon from '../ContractStatusIcon'
import track from 'src/helpers/track'
interface Props {
  showLikeIcon?: boolean
  showDealersIcon?: boolean
  showEyeIcon?: boolean
  showOfferHashId?: boolean
  offerUrl?: string | null
}

const ListLeftColumn = ({
  showLikeIcon = true,
  showDealersIcon = true,
  showEyeIcon = true,
  showOfferHashId = false
}: Props): JSX.Element => {
  const itemContext = useContext(ItemContext)
  if (itemContext === null) {
    throw new Error('itemContext must be used within a ItemProvider')
  }

  const dispatchItemContext = useContext(ItemDispatchContext)

  if (dispatchItemContext === null) {
    throw new Error('itemContext must be used within a UserProvider')
  }
  const { photo, label1, label2, is_liked, id, score, offer_hash_id, contract_status } = itemContext

  const dispatch = useDispatch()

  return (
    <View className="flex">
      <ScoreBar score={score} />
      <Space x={4} />
      <img className="w-[112px] h-22 rounded-2 object-cover" src={photo ?? '/assets/images/no_photo@x2.png'} />
      <Space x={6} />
      <View className="flex-col">
        <Text className="text-[20px] font-Bold">{label1}</Text>
        <Space y={2} />
        <Text className="text-m">{label2}</Text>
        <Space y={2} />
        <View className="flex">
          {showOfferHashId && <Text className="text-xl">{offer_hash_id}</Text>}
          {showEyeIcon && (
            <EyeSvg
              data-testid="offer-link"
              className="w-8 h-8 text-groupBlue cursor-pointer"
              onClick={() => {
                dispatch(OPEN_OFFER({ offerId: id }))
              }}
            />
          )}
          {contract_status !== null && (
            <>
              <Space x={2} />
              <ContractStatusIcon contractStatus={contract_status} className="!w-8 !h-8" />
            </>
          )}
          {showLikeIcon && (
            <>
              <Space x={2} />
              <LikedSvg
                variant={is_liked ? 'liked' : 'not_liked'}
                className="w-8 h-8 cursor-pointer pt-1"
                onClick={(e) => {
                  e.stopPropagation()
                  track('dealer_toggle_liked')
                  dispatch(TOGGLE_LIKED_OFFER({ is_liked, offer_id: id }))
                  dispatchItemContext({ type: 'TOGGLE_LIKED_OFFER_SUCCESS' })
                }}
              />
            </>
          )}
        </View>
      </View>
    </View>
  )
}

export default ListLeftColumn
